// @flow
'use strict';

import { Button } from 'react-bootstrap';
import React from 'react';

import ModalClassificacaoFiscal from '../modal_classificacao_fiscal';
import Icone from '../../../common/icone';

type ClassificaDocumentoProps = {
  url? : string,
  open : bool,
  abreModal : () => void,
  carregaListaClassificacao : () => void,
}

/**
 * O botão da classificação fiscal com modal.
 *
 * @param url se estiver vazia, o botão ficará desabilitado
 * @param open indica se modal está aberto
 * @param abreModal função para apresentar modal
 * @param carregaListaClassificacao função para carregar opções de seletor do modal
 * @param props restante das propriedades, serão repassadas ao componente de modal
 */
export default function ClassificaDocumento({ url, open, abreModal, carregaListaClassificacao, ...props  } : ClassificaDocumentoProps) {
  const abreModalClassificacao = React.useCallback(async() => {
    await carregaListaClassificacao();
    await abreModal();
  }, [carregaListaClassificacao, abreModal]);

  if (url) {
    return (
        <div>
          <Button className="btn btn-action btn-block" type="button" onClick={ abreModalClassificacao }>
            <Icone nome="pencil-alt" estilo="fas">Classificar</Icone>
          </Button>

          { open && <ModalClassificacaoFiscal { ...props } url={ url }/>}
        </div>);
  }

  return (
      <Button disabled block className="btn-action">
        Classificar
      </Button>
  );
}